import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { AppShell } from "@/components/AppShell";
import { useSupportEnabled } from "@/hooks/useSupportEnabled";
import { Gauge, Buildings, Ticket, Timer, ClipboardText } from "@phosphor-icons/react";

const TABS = [
  { to: "/helpdesk", label: "Dashboard", icon: Gauge, end: true },
  { to: "/helpdesk/customers", label: "Customers", icon: Buildings },
  { to: "/helpdesk/tickets", label: "Tickets", icon: Ticket },
  { to: "/helpdesk/time", label: "Time Entries", icon: Timer },
  { to: "/helpdesk/needs-review", label: "Needs Review", icon: ClipboardText },
];

export default function SupportLayout() {
  const { enabled, loaded } = useSupportEnabled();
  const navigate = useNavigate();
  useEffect(() => { if (loaded && !enabled) navigate("/dashboard", { replace: true }); }, [loaded, enabled, navigate]);

  return (
    <AppShell>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
        <div className="flex items-center gap-1 overflow-x-auto border-b border-white/10 mb-6" data-testid="support-subnav">
          {TABS.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={`support-tab-${t.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) => `flex items-center gap-2 px-3 py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${isActive ? "border-blue-500 text-white" : "border-transparent text-zinc-400 hover:text-white"}`}>
              <t.icon size={16} /> {t.label}
            </NavLink>
          ))}
        </div>
        <Outlet />
      </div>
    </AppShell>
  );
}
